// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"2bda1547","638":"a64464d7"}[chunkId] + ".chunk.js";
};